export const defaultTriggerStyles = {
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  gap: '8px',
  p: '10px',
  lineHeight: '20px',
  borderRadius: '3px',
  border: '1px solid',
  borderColor: 'light-dark(var(--brand-grey-200), var(--brand-grey-400))',
  color: 'light-dark(var(--brand-grey-400), var(--brand-grey-200))',
  background: 'light-dark(white, var(--brand-grey-600))',
  transition: 'all 0.15s linear',
  cursor: 'pointer',
  '[data-name="ChevronIcon"]': {
    color: 'grey300'
  },
  '&:hover': {
    background: 'light-dark(var(--brand-grey-50), var(--brand-grey-500))',
    borderColor: 'light-dark(var(--brand-grey-200),var(--brand-grey-300))'
  },
  '&:focus-visible': {
    outline: '2px solid',
    outlineColor: 'blue300',
    outlineOffset: '-1px'
  },
  '&.success': {
    borderColor: 'green200',
    '&:focus-visible': {
      outlineColor: 'green200'
    }
  },
  '&.error': {
    borderColor: 'red200',
    '&:focus-visible': {
      outlineColor: 'red200'
    }
  },
  '&.warning': {
    borderColor: 'yellow400',
    '&:focus-visible': {
      outlineColor: 'yellow400'
    }
  },
  '&.disabled': {
    color: 'light-dark(var(--brand-grey-400), var(--brand-grey-400))',
    borderColor: 'light-dark(var(--brand-grey-200), var(--brand-grey-500))',
    backgroundColor: 'light-dark(var(--brand-grey-50), var(--brand-grey-700))',
    '&:hover': {
      borderColor: 'light-dark(var(--brand-grey-200), var(--brand-grey-500))',
      color: 'light-dark(var(--brand-grey-400), var(--brand-grey-400))'
    },
    '&:focus-visible': {
      outlineColor: 'grey200'
    }
  }
}

export const defaultContentStyles = {
  '[cmdk-list][role="listbox"]': {
    maxWidth: 'none'
  }
}
